import React from 'react';
import { StepProps } from '../MultiStepModal';
import { FormField, TextInput, TextArea } from '../../ui';

export default function ClientAddressStep({ data, onDataChange }: StepProps) {
  const setField = (field: string, value: any) => onDataChange({ [field]: value });
  const marketingOptIn = Boolean(data.marketingOptIn);

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Primary address & notes</h3>
        <p className="step-form-subtitle">
          The main address on file. You can add extra sites separately from the client record.
        </p>
      </div>

      <div className="ui-wizard-section">
        <h4 className="ui-wizard-section-title">Address</h4>
        <div className="ui-wizard-grid">
          <FormField label="Address line 1" required htmlFor="customerAddress" className="ui-wizard-grid-col-span">
            <TextInput
              id="customerAddress"
              placeholder="123 Oak Street"
              value={data.customerAddress || ''}
              onChange={(e) => setField('customerAddress', e.target.value)}
            />
          </FormField>

          <FormField label="Address line 2" htmlFor="addressLine2" className="ui-wizard-grid-col-span">
            <TextInput
              id="addressLine2"
              placeholder="Apartment, suite, unit, etc."
              value={data.addressLine2 || ''}
              onChange={(e) => setField('addressLine2', e.target.value)}
            />
          </FormField>

          <FormField label="Town / city" htmlFor="city">
            <TextInput
              id="city"
              placeholder="London"
              value={data.city || ''}
              onChange={(e) => setField('city', e.target.value)}
            />
          </FormField>

          <FormField label="Postcode" htmlFor="postcode">
            <TextInput
              id="postcode"
              placeholder="SW1A 1AA"
              value={data.postcode || ''}
              onChange={(e) => setField('postcode', e.target.value.toUpperCase())}
            />
          </FormField>

          <FormField label="Country" htmlFor="country" className="ui-wizard-grid-col-span">
            <TextInput
              id="country"
              value={data.country || 'United Kingdom'}
              onChange={(e) => setField('country', e.target.value)}
            />
          </FormField>
        </div>
      </div>

      <div className="ui-wizard-section">
        <h4 className="ui-wizard-section-title">Notes (internal)</h4>
        <FormField htmlFor="notes" help="These notes are only visible to your team.">
          <TextArea
            id="notes"
            rows={3}
            placeholder="e.g. Access via side gate, prefers afternoon slots…"
            value={data.notes || ''}
            onChange={(e) => setField('notes', e.target.value)}
          />
        </FormField>
      </div>

      <div className="ui-wizard-section">
        <h4 className="ui-wizard-section-title">Marketing consent</h4>
        <label className="ui-wizard-checkbox">
          <input
            type="checkbox"
            checked={marketingOptIn}
            onChange={(e) => setField('marketingOptIn', e.target.checked)}
          />
          <span>
            Client has agreed to receive marketing emails (reminders, promos, news). You can always
            change this later.
          </span>
        </label>
        <p className="ui-wizard-section-subtitle">
          Operational emails (invoices, certificates, appointment confirmations) are always sent.
        </p>
      </div>
    </div>
  );
}
